<div class="flex flex-wrap gap-2">
  @if (showImageUploadAction()) {
    <button
      [disabled]="isUploadDisabled()"
      (click)="imageInput.click()"
      class="border border-neutral-400 rounded-full px-3 py-1 text-xs"
    >
      From Image
    </button>

    <input
      #imageInput
      [accept]="allowedImageFileTypes()"
      [multiple]="isMultipleImageUploadAllowed()"
      (change)="onFileSelected($event)"
      class="hidden"
      type="file"
    />
  }

  @if (showBpmnUploadAction()) {
    <button
      [disabled]="isUploadDisabled()"
      (click)="bpmnInput.click()"
      class="border border-neutral-400 rounded-full px-3 py-1 text-xs"
    >
      From BPMN
    </button>

    <input
      #bpmnInput
      [accept]="allowedBpmnFileTypes()"
      (change)="onFileSelected($event)"
      class="hidden"
      type="file"
    />
  }

  @if (showFromDocumentsAction()) {
    <button
      [disabled]="isUploadDisabled()"
      (click)="checkContextDocuments()"
      class="border border-neutral-400 rounded-full px-3 py-1 text-xs"
    >
      From Documents
    </button>
  }
</div>
